import { render, staticRenderFns } from "./lista-expedientes.vue?vue&type=template&id=15d9ef54&"
import script from "./lista-expedientes.vue?vue&type=script&lang=js&"
export * from "./lista-expedientes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports